import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
} from '@mui/material';
import {
  Receipt as ReceiptIcon,
  LocalOffer as TaxIcon,
  Assignment as StateIcon,
  Description as DnreIcon,
} from '@mui/icons-material';
import TaxesTab from './TaxesTab';
import StatesTab from './StatesTab';
import DnreTab from './DnreTab';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`invoice-tabpanel-${index}`}
      aria-labelledby={`invoice-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `invoice-tab-${index}`,
    'aria-controls': `invoice-tabpanel-${index}`,
  };
}

const Invoices: React.FC = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
        <ReceiptIcon color="primary" fontSize="large" />
        <Typography variant="h5" fontWeight={600}>
          {t('configInvoices.title')}
        </Typography>
      </Box>

      <Paper sx={{ mb: 2 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="invoice configuration tabs"
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            '& .MuiTab-root': {
              minHeight: 56,
              fontWeight: 500,
            },
          }}
        >
          <Tab
            icon={<TaxIcon />}
            iconPosition="start"
            label={t('configInvoices.taxes')}
            {...a11yProps(0)}
          />
          <Tab
            icon={<StateIcon />}
            iconPosition="start"
            label={t('configInvoices.state')}
            {...a11yProps(1)}
          />
          <Tab
            icon={<DnreIcon />}
            iconPosition="start"
            label={t('configInvoices.dnre')}
            {...a11yProps(2)}
          />
        </Tabs>
      </Paper>

      <TabPanel value={tabValue} index={0}>
        <TaxesTab />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <StatesTab />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <DnreTab />
      </TabPanel>
    </Box>
  );
};

export default Invoices;
